import {
  Paper,
  Select,
  Title,
  Text,
  Flex,
  Center,
  Loader,
  Avatar,
  Group,
} from "@mantine/core";
import { useMedplum } from "@medplum/react";
import { IconChevronRight } from "@tabler/icons-react";
import { forwardRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import svg from ".././../assets/img/Dexcom.svg"
import EEpic from "../../assets/img/epic.svg";
import cerner from "../../assets/img/cerner.svg";
import aaathena from "../../assets/img/athenahealth.svg";
import others from "../../assets/img/others.svg";
import EpicSelect from "../../assets/img/EpicPatint.svg";
import cernerSelecr from "../../assets/img/CernerPatient.svg";
import aaathenaSelect from "../../assets/img/AthenaPatient.svg";


export function MedicationList() {
  const medplum = useMedplum();
  const navigate = useNavigate();
  const [patientList, setPatientList] = useState<any>([]);
  const [selectedPatient, setSelectedPatient] = useState<any>(null);
  const [medicationList, setMedicationList] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(true);


  useEffect(() => {
    getPatientList();
  }, []);

  useEffect(() => {
    setIsFetching(true);
    setMedicationList([]);
    getMedications(selectedPatient);
  }, [selectedPatient]);


  const getMedications = async (id: any) => {
    const medications = await medplum.searchResources(
      "MedicationRequest",
      "patient=" + id
    );
    setMedicationList(medications);
    setIsFetching(false);
  };

  const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if ((res?.use === "official" || res?.use === "usual") && name === "--") {
          name = res?.text || res?.given[0];
        } 
      });
      if (name === "--") name = patientData[0]?.text || patientData[0]?.given || "--"
      if (typeof name !== "string") {
        name = String(name);
      }
    }
    return name;
  }
  const getPatientList = async () => {
    setIsLoading(true)
    const res = await medplum.searchResources("Patient", "_count=500");
    const patientData = res.map((patient) => {
      const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
        (coding) => coding.system?.includes("cerner")
      );
      const containsAthena = patient?.identifier?.some(
        (item) => item.system && item.system.includes("athena")
      );
      let ehrtype = "";
      if (
        patient?.identifier?.find(
          (id) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
        )
      ) {
        ehrtype = "EPIC";
      } else if (containsCerner) {
        ehrtype = "Cerner";
      } else if (containsAthena) {
        ehrtype = "Athena Health";
      } else {
        ehrtype = "Others";
      }
      let EHRIcon;
      switch (ehrtype) {
        case "EPIC":
          EHRIcon = (
            <img
              src={EpicSelect}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="EPIC"
            />
          );
          break;
        case "Cerner":
          EHRIcon = (
            <img
              src={cernerSelecr}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Cerner"
            />
          );
          break;
        case "Athena Health":
          EHRIcon = (
            <img
              src={aaathenaSelect}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Athena"
            />
          );
          break;
        default:
          EHRIcon = (
            <img
              src={others}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Others"
            />
          );
      }
      return {
        label: getPatientName(patient.name),
        value: patient.id,
        ehr: ehrtype,
        icon:EHRIcon
      };
    });

    setSelectedPatient(patientData[0].value);
    setIsLoading(false)
    setPatientList(patientData);
  };

  const getSelectedPaitentName = (id: string) => {
    let res = patientList.filter((patient: any) => {
      return patient.value === id;
    });
    return res[0].label;
  };
  let ehrtypes = "";


interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
  label: string;
  value: any;
  ehr:string;
  icon:any
}
const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
  ({ label, value, ehr,icon , ...others }: ItemProps, ref) => (
    <div ref={ref} {...others}>
      <Group noWrap sx={{justifyContent:"space-between",height:"30px",width:"100%"}}>
        <div >
          <Text >{label}</Text>
         </div>
         <div >{icon}</div>
      </Group>
    </div>
  )
);


  return (
    <>
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Title size="26px" weight={700}>
          Medications
        </Title>
        <Select
          label="Select patient"
          placeholder={isLoading ? "Loading..." : "Search medications"}
          required={true}
          data={patientList}
          rightSection={isLoading ? <Loader size={"sm"} /> : ""}
          mt="lg"
          size="lg"
          radius="md"
          value={selectedPatient}
          onChange={(val) => {
            setSelectedPatient(val);
          }}
          clearable={true}
          sx={{
            ".mantine-Select-itemsWrapper": {
              paddingRight: "10px",
            },
          }}
          searchable
          itemComponent={SelectItem}
        />
        <Title size="18px" mt="lg" weight={700}>
          Medications List
        </Title>
        {medicationList.map((med: any) => (
          <Flex
            justify={"space-between"}
            align={"center"}
            pt={"16px"}
            pb={"16px"}
            pl={"10px"}
            pr={"10px"}
            bg={"rgba(241, 249, 255, 1)"}
            mt="md"
            mb="md"
            sx={{ borderRadius: "4px", cursor: "pointer" }}
            onClick={() =>
              navigate(
                `./${med.id}?name=${getSelectedPaitentName(selectedPatient)}`
              )
            }
          >
            <div>
              <Text weight={500} mb={4}>
                {med?.medicationReference?.display?.toUpperCase()}
              </Text>
              <Text c="gray.6">{med.requester?.display}</Text>
            </div>
            <IconChevronRight />
          </Flex>
        ))}
        {medicationList?.length === 0 && !isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Text size="xl" color="dimmed">
              No results
            </Text>
          </Center>
        )}
        {isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Loader />
          </Center>
        )}
      </Paper>
    </>
  );
}
